import React, { Component } from "react";
import $, { data } from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { tokenVerification } from "./Utils";
class NewPatientAdmission extends Component {
  constructor() {
    super();

    const date = new Date();
    var minute = date.getMinutes();
    if (date.getMinutes() > 0 && date.getMinutes() < 10) {
      minute = "0" + date.getMinutes();
    }
    const showCurrentTime = date.getHours() + ":" + minute;
    var currentDate = new Date();
    var dd = currentDate.getDate() + 1;
    var mm = currentDate.getMonth() + 1;
    var yyyy = currentDate.getFullYear();
    let tomorrow = new Date();
    tomorrow.setDate(currentDate.getDate() + 1);

    this.state = {
      selectedPhysicianName: "",
      dontOverLap: false,
      selectedHealthSystemId: "",
      selectedHospitalId: "",
      selectedServiceLineId: "",
      selectedProcedureId: "",
      selectedPhysicianId: "",
      showQrCodeButton: false,
      showQrCode: false,
      qrCode: "",
      showLoader: false,
      error: "",
      healthSystemId: "",
      hospitalId: "",
      serviceLineId: "",
      procedureId: "",
      physicianId: "",
      selectedAdmissionDate: currentDate,
      selectedTreatmentDate: tomorrow,
      showEditBtn: false,
      patientId: "",
      currentpatientId: "",
      patientName: "",
      patientEmailId: "",
      patientContactNumber: "",
      value: [],
      data: [
        {
          id: "",
          name: "",
          phoneNumber: "",
          emailId: "",
        },
      ],
      disabled: false,
      editedId: "-1",
      editImageSrc: "./assets/images/edit.svg",
      contentEditable: "false",
      hidden: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      pageNum: null,
      userRoleId: "",
      admissionTime: this.getCurrentTime(),
      showpreviewModeOverLay: false,
      editable: true,
      healthSystemGroupValue: [],
      hospitalGroupValue: [],
      serviceLineGroupValue: [],
      treatmentGroupValue: [],
      providerGroupValue: [],
      isToastDisplayed: false,
    };

    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    this.healthSystemDropDownInNewPatientAdmissionRef = React.createRef();
    this.hospitalDropDownInNewPatientAdmissionRef = React.createRef();
    this.serviceLineDropDownInNewPatientAdmissionRef = React.createRef();
  }
  componentDidMount() {
    var thisController = this;
    thisController.state.selectedHealthSystemId =
      localStorage.getItem("healthSystemId");
    thisController.state.selectedHospitalId =
      localStorage.getItem("hospitalId");
    thisController.state.selectedServiceLineId =
      localStorage.getItem("serviceLineId");
    thisController.setState(thisController.state);
    const date = new Date();
    var minute = date.getMinutes();
    if (date.getMinutes() > 0 && date.getMinutes() < 10) {
      minute = "0" + date.getMinutes();
    }
    const showCurrentTime = date.getHours() + ":" + minute;
    thisController.state.admissionTime = showCurrentTime;
    var userRole = thisController.userDetails["userRole"];
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      thisController.state.healthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.fetchHospitalDetails();
    } else if (
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PROCEDURE_ADMIN" ||
      userRole == "PHYSICIAN" ||
      userRole == "NURSE"
    ) {
      thisController.state.healthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.hospitalId =
        thisController.userDetails["hospitalId"];
      thisController.fetchServiceLineDetails();
    } else {
      //THIS IS THE CASE OF SUPER ADMIN
      thisController.fetchHealthSystemDetails();
    }
  }
  fetchHealthSystemDetails() {
    var thisController = this;
    var responseData = [];
    $.ajax({
      url: "/my-jeeva-api/health-system",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.healthSystemGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.healthSystemGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }

          thisController.setState(thisController.state);

          if (!thisController.state.selectedHealthSystemId) {
            var healthSystemsDropDownList =
              thisController.healthSystemDropDownInNewPatientAdmissionRef
                .current;
            if (healthSystemsDropDownList) {
              thisController.state.selectedHealthSystemId =
                healthSystemsDropDownList.value;
              setTimeout(() => {
                thisController.onHealthSystemChange({
                  target:
                    thisController.healthSystemDropDownInNewPatientAdmissionRef
                      .current,
                });
              }, 100);
            } else {
              thisController.state.selectedHealthSystemId = res.result[0].id;
              setTimeout(() => {
                thisController.onHealthSystemChange({
                  target:
                    thisController.healthSystemDropDownInNewPatientAdmissionRef
                      .current,
                });
              }, 100);
            }
          }
          thisController.setState(thisController.state);
          thisController.fetchHospitalDetails();
        } else {
          thisController.notifyFailed(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  getCurrentTime() {
    var currentDate = new Date();

    var hours = String(currentDate.getHours()).padStart(2, "0");

    var minutes = String(currentDate.getMinutes()).padStart(2, "0");

    var formattedTime = hours + ":" + minutes;
    return formattedTime;
  }
  fetchHospitalDetails() {
    var thisController = this;
    var responseData = [];
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.state.healthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.setState(thisController.state);
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
    }
    $.ajax({
      url: "/my-jeeva-api/hospital",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        healthSystemId: healthSystemId,
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.hospitalGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.hospitalGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }
          if (!thisController.state.selectedHospitalId) {
            if (totalCount > 0) {
              thisController.state.selectedHospitalId = res.result[0].id;
              thisController.state.selectedServiceLineId = null;
              setTimeout(() => {
                thisController.onHospitalChange({
                  target:
                    thisController.hospitalDropDownInNewPatientAdmissionRef
                      .current,
                });
              }, 100);
            } else {
              thisController.state.selectedHospitalId = null;
            }
          }
          thisController.setState(thisController.state);
          thisController.fetchServiceLineDetails();
        } else {
          thisController.notifyFailed(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  fetchServiceLineDetails() {
    var thisController = this;
    var responseData = [];
    var userRole = thisController.userDetails["userRole"];
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
    } else if (
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      this.state.selectedHospitalId = thisController.userDetails["hospitalId"];
    }
    this.setState(this.state);
    var selectedHospital;
    if (thisController.state.selectedHospitalId == null || thisController.state.selectedHospitalId == "null") {
      selectedHospital = "00000000-0000-0000-0000-000000000000";
    } else {
      selectedHospital = thisController.state.selectedHospitalId;
    }
    $.ajax({
      url: "/my-jeeva-api/service-line",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        healthSystemId: thisController.state.selectedHealthSystemId,
        hospitalId: selectedHospital,
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.serviceLineGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.serviceLineGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }
          if (!thisController.state.selectedServiceLineId) {
            if (totalCount > 0) {
              thisController.state.selectedServiceLineId = res.result[0].id;
              setTimeout(() => {
                thisController.onServiceLineChange({
                  target:
                    thisController.serviceLineDropDownInNewPatientAdmissionRef
                      .current,
                });
              }, 100);
            } else {
              thisController.state.selectedServiceLineId = null;
            }
          }
          thisController.setState(thisController.state);
          thisController.fetchProcedureDetails();
        } else {
          thisController.notifyFailed(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }
  fetchProcedureDetails = () => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
    } else if (userRole == "HOSPITAL_ADMIN") {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      this.state.selectedHospitalId = thisController.userDetails["hospitalId"];
    } else if (userRole == "SERVICELINE_ADMIN" || userRole == "PHYSICIAN") {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      this.state.selectedHospitalId = thisController.userDetails["hospitalId"];
      this.state.selectedServiceLineId =
        thisController.userDetails["serviceLineId"];
      var providerId = thisController.userDetails["userId"];
    } else {
      this.state.selectedHealthSystemId =
        localStorage.getItem("healthSystemId");
      this.state.selectedHospitalId = localStorage.getItem("hospitalId");
      this.state.selectedServiceLineId = localStorage.getItem("serviceLineId");
    }
    this.setState(this.state);

    if (userRole == "PHYSICIAN") {
      $.ajax({
        url: "/my-jeeva-api/procedure-treatment",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          providerId: providerId,
          hospitalId: this.state.selectedHospitalId,
        },
        success: function (res) {
          if (res.success === true) {
            // thisController.state.data = res.result;
            thisController.state.disabled = false;
            thisController.state.showLoader = true;
            var responseData = res.result;
            responseData = responseData.filter(procedure => !procedure.isDeactivated);
            var totalCount = responseData.length;
            thisController.state.treatmentGroupValue = [];
            for (var i = 0; i < totalCount; i++) {
              thisController.state.treatmentGroupValue.push({
                name: responseData[i].name,
                value: responseData[i].id,
              });
            }
            if (totalCount > 0) {
              thisController.state.selectedProcedureId = responseData[0].id;
            } else {
              thisController.state.selectedProcedureId = null;
            }
            thisController.fetchPhysicianDetails();
            thisController.setState(thisController.state);
          } else {
            thisController.notifyFailed(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    } else {
      var responseData = this;
      if (responseData.state.selectedServiceLineId == null || responseData.state.selectedServiceLineId == "null") {
        responseData.state.selectedServiceLineId = "00000000-0000-0000-0000-000000000000";
        responseData.setState(responseData.state);
      }
      if (responseData.state.selectedHospitalId == "null") {
        responseData.state.selectedHospitalId = "00000000-0000-0000-0000-000000000000";
        responseData.setState(responseData.state);
      }
      $.ajax({
        url: "/my-jeeva-api/procedure",

        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          healthSystemId: responseData.state.selectedHealthSystemId,
          hospitalId: responseData.state.selectedHospitalId,
          serviceLineId: responseData.state.selectedServiceLineId,
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            responseData = res.result;
            responseData = responseData.filter(procedure => !procedure.isDeactivated);
            var totalCount = responseData.length;
            var totalCount = responseData.length;
            thisController.state.treatmentGroupValue = [];
            for (var i = 0; i < totalCount; i++) {
              thisController.state.treatmentGroupValue.push({
                name: responseData[i].name,
                value: responseData[i].id,
              });
            }
            // if (!localStorage.getItem('procedureId')) {
            if (totalCount > 0) {
              thisController.state.selectedProcedureId = responseData[0].id;
            } else {
              thisController.state.selectedProcedureId = null;
            }
            // }
            thisController.fetchPhysicianDetails();
            thisController.setState(thisController.state);
          } else {
            responseData.setState({ successResp: false });
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/my-jeeva/";
          }
        },
      });
    }
  };
  fetchPhysicianDetails() {
    var thisController = this;
    var healthSystemId = localStorage.getItem("healthSystemId");
    var hospitalId;
    if (thisController.state.selectedHospitalId == null || thisController.state.selectedHospitalId == "null") {
      hospitalId = "00000000-0000-0000-0000-000000000000";
    } else {
      hospitalId = thisController.state.selectedHospitalId;
    }
    localStorage.getItem("hospitalId");
    var procedureId;
    if (thisController.state.selectedProcedureId == null || thisController.state.selectedProcedureId == "null") {
      procedureId = "00000000-0000-0000-0000-000000000000";
    } else {
      procedureId = thisController.state.selectedProcedureId;
    }

    var data = {
      role: "PHYSICIAN",
      healthSystemId: healthSystemId,
      hospitalId: hospitalId,
      //To pass the service line id it should not be dummy id
      serviceLineId: thisController.state.selectedServiceLineId,
    };

    $.ajax({
      url: "/my-jeeva-api/physicians",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        procedureId : procedureId,
      },
      success: function (res) {
        if (res.success === true) {
          var responseData = res.result;
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          var totalCount = responseData.length;
          thisController.state.providerGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.providerGroupValue.push({
              name: res.result[i].userName,
              value: res.result[i].id,
            });
          }
          if (totalCount > 0) {
            thisController.state.selectedPhysicianId = res.result[0].id;
            thisController.state.selectedPhysicianName = res.result[0].userName;
          } else {
            thisController.state.selectedPhysicianId = null;
            thisController.state.selectedPhysicianName = null;
          }

          thisController.setState(thisController.state);
        } else {
          thisController.setState({ successResp: false });
          thisController.setState(thisController.state);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva/";
        }
      },
    });
  }
  savePatientDetails = () => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    if (thisController.userDetails["userRole"] == "PHYSICIAN") {
      thisController.state.selectedPhysicianName =
        thisController.userDetails["name"];
    }
    var pattern = new RegExp(
      /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/
    );
    var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
    var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{6,17}$/);
    // new RegExp(/^\+?[1-9]\d{1,3}[-\s]?\d{3,4}[-\s]?\d{4}$/);
    var userName = thisController.state.patientName.trim();
    var userId = thisController.state.patientId;
    var userPhoneNumber = thisController.state.patientContactNumber.trim();
    var userEmailId = thisController.state.patientEmailId.toLowerCase();
    var admissionTime = thisController.state.admissionTime.split(":");
    var date = new Date(thisController.state.selectedAdmissionDate);
    var selDate = date.getDate();
    var selMonth = date.getMonth() + 1;
    var selYear = date.getFullYear();
    if (selDate < 10) {
      selDate = '0' + selDate;
    }
    if (selMonth < 10) {
      selMonth = '0' + selMonth;
    }

    var dateString = selMonth + "/" + selDate + "/" + selYear;
    var currentDate = new Date();
    var curDate = currentDate.getDate();
    var curMonth = currentDate.getMonth() + 1;
    var curYear = currentDate.getFullYear();

    if (userRole == "HEALTHSYSTEM_ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
    } else if (userRole == "HOSPITAL_ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId =
        thisController.userDetails["hospitalId"];
    } else if (userRole == "SERVICELINE_ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId =
        thisController.userDetails["hospitalId"];
      thisController.state.selectedServiceLineId =
        thisController.userDetails["serviceLineId"];
    } else if (userRole == "PHYSICIAN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId =
        thisController.userDetails["hospitalId"];
      thisController.state.selectedServiceLineId =
        thisController.userDetails["serviceLineId"];
      thisController.state.selectedProcedureId =
        thisController.state.selectedProcedureId;
      thisController.state.selectedPhysicianId =
        thisController.userDetails["userId"];
    }
    if (thisController.state.selectedHealthSystemId == "Select Health System") {
      thisController.notifySelectHealthSystem();
    } else if (thisController.state.selectedHospitalId == "Select Hospital") {
      thisController.notifySelectHospital();
    } else if (
      thisController.state.selectedServiceLineId == "Select Service Line"
    ) {
      thisController.notifySelectServiceLine();
    } else if (thisController.state.selectedProcedureId == "Select Procedure") {
      thisController.notifySelectProcedure();
    } else if (thisController.state.selectedPhysicianId == "Select Physician") {
      thisController.notifySelectPhysician();
    } else if (
      thisController.state.patientName == "" ||
      thisController.state.patientContactNumber == "" ||
      thisController.state.patientEmailId == "" ||
      admissionTime[0] == "" ||
      admissionTime[1] == "" ||
      admissionTime == ""
    ) {
      thisController.notifyEmptyFields();
    } else if (userName == "" || userPhoneNumber == "" || userEmailId == "") {
      thisController.notifyEmptyFields();
    } else if (!namePattern.test(userName)) {
      thisController.notifyImproperName();
    } else if (!contactNumberPattern.test(userPhoneNumber)) {
      thisController.notifyImproperContactNumber();
    } else if (!pattern.test(userEmailId)) {
      thisController.notifyImproperEmailId();
    } else if (selYear < curYear) {
      this.notifyImproperDate();
    } else if (selYear == curYear && selMonth < curMonth) {
      this.notifyImproperDate();
    } else if (selYear == curYear && selMonth == curMonth && selDate < curDate) {
      this.notifyImproperDate();
    } else {
      var saveData = {
        userId: thisController.state.patientId,
        userName: thisController.state.patientName,
        userPhoneNumber: thisController.state.patientContactNumber,
        userEmailId: thisController.state.patientEmailId,
        userRole: "PHYSICIAN",
        healthSystemId: thisController.state.selectedHealthSystemId,
        serviceLineId: thisController.state.selectedServiceLineId,
        hospitalId: thisController.state.selectedHospitalId,
        procedureId: thisController.state.selectedProcedureId,
        physicianId: thisController.state.selectedPhysicianId,
        admissionDate: dateString,
        admissionTime: thisController.state.admissionTime,
        treatmentDate: document.getElementById("treatmentDate").value,
        physicianName: thisController.state.selectedPhysicianName,
      };
      if (thisController.state.selectedPhysicianName != null) {
        $.ajax({
          url: "/my-jeeva-api/patient-admission",

          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
          },
          data: JSON.stringify(saveData),
          success: function (res) {
            if (res.success === true) {
              if (res.result == "AlreadyEnrolled") {
                thisController.notifyPatientAlreadyEnrolled();
              } else {
                thisController.notifyPatientAdded();
                thisController.state.showQrCodeButton = true;
                thisController.state.editedId = "-1";
                thisController.state.patientName = res.result.userName;
                thisController.state.admissionTime = res.result.admissionTime;
                thisController.state.patientEmailId = res.result.userEmailId;
                thisController.state.currentpatientId = res.result.id;
                thisController.state.patientContactNumber =
                  res.result.userPhoneNumber;
                thisController.state.editable = false;
                thisController.setState({ disabled: false });
                thisController.setState(thisController.state);
              }

            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "";
            }
          },
        });
      } else {
        thisController.notifyNoPhysician();
      }
    }
  };

  // notifyNoPhysician() {
  //   toast.dismiss();
  //   toast(
  //     <b style={{ color: "red" }}>
  //       No Provider is Configured for this treatment
  //     </b>,
  //     {
  //       position: "top-center",
  //       color: "red",
  //     }
  //   );
  // }
  notifyNoPhysician() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="/my-jeeva/assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;No provider is configured for this treatment
      </b>,
      {
        position: "top-center",
      }
    );
  }
  generateQRCode = () => {
    var addUserController = this;
    $.ajax({
      url: "/my-jeeva-api/generate-qrcode",

      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        admissionId: addUserController.state.currentpatientId,
      },

      success: function (res) {
        if (res.success === true) {
          addUserController.state.showQrCode = true;
          addUserController.state.qrCode = res.result;
          addUserController.setState(addUserController.state);
          addUserController.fetchManageAdmissionDetails();
        } else {
          addUserController.notifyFailed(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  };
  fetchManageAdmissionDetails = () => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      thisController.state.healthSystemId =
        thisController.userDetails["healthSystemId"];
    } else if (
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      thisController.state.healthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.hospitalId =
        thisController.userDetails["hospitalId"];
    } else {
      thisController.state.hospitalId =
        thisController.state.selectedHealthSystemId;
      thisController.state.healthSystemId =
        thisController.state.selectedHospitalId;
    }
    $.ajax({
      url: "/my-jeeva-api/fetch-admission-details",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        healthSystemId: thisController.state.healthSystemId,
        hospitalId: thisController.state.hospitalId,
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.state.data = res.result;
          thisController.setState(thisController.state);
        } else {
          thisController.notifyFailed(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  };
  checkPatientInfo = () => {
    var checkPatientInfoController = this;
    const userEmailId = document.getElementById("patientEmailId").value;
    $.ajax({
      url: "/my-jeeva-api/check-patient-info",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        patientEmailId: userEmailId.toLowerCase(),
      },

      success: function (res) {
        if (res.success === true) {
          if (res.result == null) {
            checkPatientInfoController.state.patientName =
              checkPatientInfoController.state.patientName;
            checkPatientInfoController.state.patientContactNumber =
              checkPatientInfoController.state.patientContactNumber;
            checkPatientInfoController.setState(
              checkPatientInfoController.state
            );
          } else {
            checkPatientInfoController.state.patientName = res.result.userName;
            checkPatientInfoController.state.patientContactNumber =
              res.result.userPhoneNumber;
            checkPatientInfoController.setState(
              checkPatientInfoController.state
            );
          }
        } else {
          checkPatientInfoController.state.patientName =
            checkPatientInfoController.state.patientName;
          checkPatientInfoController.state.patientContactNumber =
            checkPatientInfoController.state.patientContactNumber;
          checkPatientInfoController.setState(checkPatientInfoController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  };

  notifyFailed() {
    toast.dismiss();
    toast(
      <b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>,
      {
        position: "top-center",
        color: "red",
      }
    );
  }

  onHealthSystemChange = (e) => {
    this.state.dontOverLap = true;
    var selectBox = e.target;
    if (selectBox) {
      if (this.state.selectedHealthSystemId != selectBox.value) {
        this.state.selectedHospitalId = null;
        this.state.selectedServiceLineId = null;
        this.state.procedureId = null;
        this.state.physicianId = null;
        localStorage.setItem(`hospitalName`, null);
        localStorage.setItem("serviceName", null);
        localStorage.setItem("hospitalId", null);
        localStorage.setItem("serviceLineId", null);
        localStorage.setItem("procedureId", null);
        localStorage.setItem("physicianId", null);
      }
      this.state.selectedHealthSystemId = selectBox.value;
      localStorage.setItem("healthSystemId", this.state.selectedHealthSystemId);
      var healthSystemName = selectBox.options[selectBox.selectedIndex].innerText;
      localStorage.setItem("healthSystemName", healthSystemName);
      window.admissionsNavBarController.paintPatientAdmissionHeading();
      //this.state.selectedHospitalId = document.getElementById("hospitalId").value;
      this.setState(this.state);
      this.fetchHospitalDetails();
    }
  };

  onHospitalChange = (e) => {
    this.state.dontOverLap = true;
    if (!this.state.selectedHospitalId) {
      localStorage.setItem("hospitalId", this.state.selectedHospitalId);
    }
    var selectBox = e.target;
    if (selectBox) {
      if (this.state.selectedHospitalId != selectBox.value) {
        this.state.selectedServiceLineId = null;
        localStorage.setItem("serviceName", null);
        localStorage.setItem("serviceLineId", null);
      }
      this.state.selectedHospitalId = selectBox.value;
      localStorage.setItem("hospitalId", selectBox.value);
      var hospitalName = selectBox.options[selectBox.selectedIndex].innerText;
      localStorage.setItem("hospitalName", hospitalName);
      window.admissionsNavBarController.paintPatientAdmissionHeading();
      this.setState(this.state);
      this.fetchServiceLineDetails();
    }
  };

  onServiceLineChange = (e) => {
    this.state.dontOverLap = true;
    var selectBox = e.target;
    if (selectBox) {
      if (this.state.selectedServiceLineId != selectBox.value) {
        this.state.procedureId = null;
        localStorage.setItem("procedureId", null);
      }
      this.state.selectedServiceLineId = selectBox.value;
      localStorage.setItem("serviceLineId", this.state.selectedServiceLineId);
      var serviceLineName = selectBox.options[selectBox.selectedIndex].innerText;
      localStorage.setItem("serviceName", serviceLineName);
      this.setState(this.state);
      window.admissionsNavBarController.paintPatientAdmissionHeading();
      this.fetchProcedureDetails();
    }
  };

  onProcedureChange = (e) => {
    this.state.dontOverLap = true;
    var selectBox = e.target;
    if (selectBox) {
      if (this.state.procedureId != selectBox.value) {
        this.state.physicianId = null;
        localStorage.setItem("physicianId", null);
      }
      this.state.selectedProcedureId = selectBox.value;
      localStorage.setItem("procedureId", this.state.selectedProcedureId);
      // this.state.selectedPhysicianId = document.getElementById("physicianId").value;

      this.setState(this.state);
      this.fetchPhysicianDetails();
    }
  };

  onPhysicianChange = (e) => {
    var selectBox = e.target;
    this.state.selectedPhysicianId = e.target.value;
    this.state.selectedPhysicianName = selectBox.options[selectBox.selectedIndex].innerText;
    localStorage.setItem("physicianId", this.state.selectedPhysicianId);
    this.setState(this.state);
  };

  makeCelledit(props, e) {
    this.markAsBeingEdited(this.state.data[props.index].id);
  }

  markAsBeingEdited(id) {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }
  closeQrCodePage = () => {
    this.setState({ showQrCode: false });
  };
  notifySelectHealthSystem() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please Select Health System
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifySelectHospital() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content="" onAdmiss
        />
        &nbsp;&nbsp;Please Select Hospital
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifySelectPhysician() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please Select Provider
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifySelectProcedure() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please Select Procedure
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifySelectServiceLine() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please Select Service Line
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyEmptyFields() {
    const toastId = "emptyFields";

    // Check if the toast with the specified toastId is already active
    const isToastActive = toast.isActive(toastId);
    if (!isToastActive || !this.state.isToastDisplayed) {
      toast(
        <b>
          <img
            src="assets/images/warn.svg"
            style={{ paddingRight: "0px", height: "20px", width: "20px" }}
            content=""
          />
          Please fill the patient details before saving
        </b>,
        {
          position: "top-center",
          color: "#007aff",
          toastId: toastId
        },
      );
    }
    this.state.isToastDisplayed = true;
    this.setState(this.state);
    setTimeout(() => {
      this.state.isToastDisplayed = false;
      this.setState(this.state);
    }, 2000)
  }

  notifyImproperName() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="/my-jeeva/assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid name
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperEmailId() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="/my-jeeva/assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid email id
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperContactNumber() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="/my-jeeva/assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid contact number
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyAlreadyExists(emailId) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="/my-jeeva/assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;A patient detail already exists with {emailId}
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyPatientAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="/my-jeeva/assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Patient Enrollment details added successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyPatientAlreadyEnrolled() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="/my-jeeva/assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Patient already Enrolled for this Treatment, Please select different Treatment.
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperDate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="/my-jeeva/assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Given date seems to be a past date. Please provide a valid
        Treatment Date
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyChangeTreatmentDate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="/my-jeeva/assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid Treatment Date
      </b>,
      {
        position: "top-center",
      }
    );
  }
  handleChangeEmailId = (e) => {
    this.state.patientEmailId = e.target.value;
    this.setState(this.state);
  };
  handleChangeContactNumber = (e) => {
    this.state.patientContactNumber = e.target.value;
    this.setState(this.state);
  };
  handleChangeName = (e) => {
    this.state.patientName = e.target.value;
    this.setState(this.state);
  };
  onAdmissionDateChange = (date) => {
    var dateObject = new Date(date);
    var onTreatmentDate = new Date(this.state.selectedTreatmentDate);
    if (dateObject > onTreatmentDate) {
      this.notifyChangeTreatmentDate();
    }
    this.state.selectedAdmissionDate = dateObject;
    this.setState(this.state);
  };
  onTreatmentDateChange = (date) => {
    var onAdmissionDate = new Date(this.state.selectedAdmissionDate);
    var onTreatmentDate = new Date(date);
    if (onTreatmentDate < onAdmissionDate) {
      this.notifyImproperDate();
    } else {
      this.state.selectedTreatmentDate = onTreatmentDate;
      this.setState(this.state);
    }
  };

  notifyImproperDate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Past dates can't be selected, Please select Today or Future
        date.
      </b>,
      {
        position: "top-center",
      }
    );
  }
  handleChangeAdmissionTime = (e) => {
    this.state.admissionTime = e.target.value;
    this.setState(this.state);
  };

  resetFiltersAndData = () => {
    const date = new Date();
    var minute = date.getMinutes();
    if (date.getMinutes() > 0 && date.getMinutes() < 10) {
      minute = "0" + date.getMinutes();
    }
    const showCurrentTime = date.getHours() + ":" + minute;
    document.getElementById("admissionTime").value = showCurrentTime;

    this.state.showQrCodeButton = false;
    this.state.patientName = "";
    this.state.patientContactNumber = "";
    this.state.patientEmailId = "";
    (this.state.procedureId = ""),
      (this.state.physicianId = ""),
      (this.state.admissionTime = showCurrentTime),
      (this.state.selectedProcedureId = ""),
      (this.state.selectedPhysicianId = ""),
      this.setState(this.state);

    this.fetchServiceLineDetails();
  };

  render() {
    return (
      <div id="tabPage" style={{ height: "530px" }}>
        <div
          className="content"
          style={{
            display: this.state.showLoader ? "block" : "none",
            backgroundColor: "#F9F9FB",
            marginLeft: "-10px",
          }}
        >
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          <ToastContainer className="Toast-at-center" />

          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <title> Dheeyantra | Clusters Details</title>
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          <link
            rel="stylesheet"
            href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link
            href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
            rel="stylesheet"
          />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <div>
            <div className="content-header">
              <div className="row">
                <div className="col-sm-2">
                  <h6
                    className="nav-item"
                    style={{
                      color: "#282a65",
                      marginTop: "1vh",
                      marginLeft: "2vw",
                    }}
                  >
                    Enroll a patient
                  </h6>
                </div>
                <div className="col-sm-8"></div>
                <div className="col-sm-2">
                  <button
                    type="button"
                    className="btn action-button"
                    style={{
                      marginTop: "6px",
                    }}
                    onClick={this.savePatientDetails}
                  >
                    <img
                      className="img-responsive cursor-change"
                      src="assets/images/baseline_save_white_24dp.png"
                    />
                  </button>
                  <button
                    className="btn action-button"
                    style={{ marginTop: "6px" }}
                    title="Refresh"
                    onClick={this.resetFiltersAndData}
                  >
                    <img src="./assets/images/refresh_white_24dp.png" />
                  </button>
                </div>
              </div>
              <div className="row" style={{ marginLeft: "1vw" }}>
                <div className="col-sm-6" Align="left" style={{ marginLeft: "0.6vw" }}>
                  <label
                    style={{
                      display:
                        window.SCOPE_VALUE.CURRENT >
                          window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN
                          ? "inline"
                          : "none",
                    }}
                  >
                    Health System
                  </label>
                  <select
                    value={this.state.selectedHealthSystemId}
                    id="healthSystem"
                    className="healthSystem"
                    onChange={(e) => this.onHealthSystemChange(e)}
                    placeholder="Select Health System"
                    ref={this.healthSystemDropDownInNewPatientAdmissionRef}
                    style={{
                      display:
                        window.SCOPE_VALUE.CURRENT >
                          window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN
                          ? "inline"
                          : "none",
                      height: "30px",
                      borderRadius: "4px",
                      backgroundColor: "#F9F9FB",
                      width: "13vw",
                      marginLeft: "10px",
                    }}
                  >
                    {this.state.healthSystemGroupValue.map((healthSystem) => (
                      <option value={healthSystem.value}>
                        {healthSystem.name}
                      </option>
                    ))}
                  </select>

                  <label
                    style={{
                      marginLeft: "3vh",
                      display:
                        window.SCOPE_VALUE.CURRENT >
                          window.SCOPE_VALUE.HOSPITAL_ADMIN
                          ? "inline"
                          : "none",
                    }}
                  >
                    Hospital
                  </label>
                  <select
                    value={this.state.selectedHospitalId}
                    id="hospitalId"
                    className="hospital"
                    onChange={(e) => this.onHospitalChange(e)}
                    placeholder="Select hospital"
                    ref={this.hospitalDropDownInNewPatientAdmissionRef}
                    style={{
                      display:
                        window.SCOPE_VALUE.CURRENT >
                          window.SCOPE_VALUE.HOSPITAL_ADMIN
                          ? "inline"
                          : "none",
                      height: "30px",
                      borderRadius: "4px",
                      backgroundColor: "#F9F9FB",
                      width: "13vw",
                      marginLeft: "10px",
                    }}
                  >
                    {this.state.hospitalGroupValue.map((hospitalGroup) => (
                      <option value={hospitalGroup.value}>
                        {hospitalGroup.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-sm-6"></div>
              </div>
            </div>

            <div className="card-body p-0 mb-25" style={{ marginLeft: "2vw" }}>
              <div className="tab-content col-12 p-0">
                <div className="tab-pane active show" id="tab_1">
                  <div className="card card-primary mt-3">
                    <form role="form" className="raiseTicketLable">
                      <div className="card-body raise-form">
                        <div className="form-group">
                          <div className="row">
                            <div className="col-sm-2">
                              <label
                                style={{ color: "black", fontSize: "15px" }}
                              >
                                Time
                              </label>
                            </div>
                            <div className="col-sm-1">:</div>
                            <div className="col-sm-2">
                              <input
                                type="time"
                                className="form-control col-11"
                                id="admissionTime"
                                name="time"
                                placeholder="Enter Time"
                                value={this.state.admissionTime || this.getCurrentTime()}
                                style={{
                                  width: "95%",
                                  cursor: "pointer",
                                  border: "1px solid #D2D4DC",
                                  borderRadius: "4px",
                                }}
                                onChange={this.handleChangeAdmissionTime}
                              />
                            </div>
                            <div className="col-sm-1"></div>
                            <div className="col-sm-2">
                              <label
                                style={{ color: "black", fontSize: "15px" }}
                              >
                                Enrollment Date
                              </label>
                            </div>
                            <div className="col-sm-1">:</div>
                            <div className="col-sm-3">
                              <DatePicker
                                style={{
                                  width: "10px",
                                  marginLeft: "70%",
                                  cursor: "pointer",
                                }}
                                autoOk={true}
                                id="admissionDate"
                                selected={this.state.selectedAdmissionDate}
                                onChange={this.onAdmissionDateChange}
                                dateFormat="MM/dd/yyyy"
                              ></DatePicker>
                            </div>
                          </div>

                          <div className="row" style={{ marginTop: "1vw" }}>
                            <div className="col-sm-2">
                              <label
                                style={{ color: "black", fontSize: "15px" }}
                              >
                                Patient Email ID
                              </label>
                            </div>
                            <div className="col-sm-1">:</div>
                            <div className="col-sm-2">
                              <input
                                type="email"
                                id="patientEmailId"
                                name="emailId"
                                placeholder="Enter Patient EmailId"
                                value={this.state.patientEmailId}
                                onBlur={this.checkPatientInfo}
                                onChange={this.handleChangeEmailId}
                                style={{
                                  padding: "0.375rem 0.75rem",
                                  textAlign: "left",
                                  borderBottom: "1px solid #b2b2b2",
                                }}
                              />
                            </div>
                            <div className="col-sm-1"></div>
                            <div className="col-sm-2">
                              <label
                                style={{
                                  color: "black",
                                  fontSize: "15px",
                                  display:
                                    window.SCOPE_VALUE.CURRENT >
                                      window.SCOPE_VALUE.SERVICELINE_ADMIN
                                      ? "inline"
                                      : "none",
                                }}
                              >
                                Service Line
                              </label>
                            </div>
                            <div
                              className="col-sm-1"
                              style={{
                                display:
                                  window.SCOPE_VALUE.CURRENT >
                                    window.SCOPE_VALUE.SERVICELINE_ADMIN
                                    ? "inline"
                                    : "none",
                              }}
                            >
                              :
                            </div>
                            <div className="col-sm-3">
                              <select
                                value={this.state.selectedServiceLineId}
                                id="serviceLineId"
                                className="hospital"
                                onChange={(e) => this.onServiceLineChange(e)}
                                placeholder="Select serviceline"
                                ref={
                                  this
                                    .serviceLineDropDownInNewPatientAdmissionRef
                                }
                                style={{
                                  display:
                                    window.SCOPE_VALUE.CURRENT >
                                      window.SCOPE_VALUE.SERVICELINE_ADMIN
                                      ? "inline"
                                      : "none",
                                  height: "30px",
                                  borderRadius: "4px",
                                  backgroundColor: "#F9F9FB",
                                  width: "13vw",
                                }}
                              >
                                {this.state.serviceLineGroupValue.map(
                                  (serviceLineGroup) => (
                                    <option value={serviceLineGroup.value}>
                                      {serviceLineGroup.name}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                          </div>

                          <div className="row" style={{ marginTop: "1vw" }}>
                            <div className="col-sm-2">
                              <label
                                style={{ color: "black", fontSize: "15px" }}
                              >
                                Patient Name
                              </label>
                            </div>
                            <div className="col-sm-1">:</div>
                            <div className="col-sm-2">
                              <input
                                type="text"
                                id="patientName"
                                name="name"
                                placeholder="Enter Patient Name"
                                value={this.state.patientName}
                                onChange={this.handleChangeName}
                                style={{
                                  padding: "0.375rem 0.75rem",
                                  textAlign: "left",
                                  borderBottom: "1px solid #b2b2b2",
                                }}
                              />
                            </div>
                            <div className="col-sm-1"></div>
                            <div className="col-sm-2">
                              <label
                                style={{ color: "black", fontSize: "15px" }}
                              >
                                Treatment
                              </label>
                            </div>
                            <div className="col-sm-1">:</div>
                            <div className="col-sm-3">
                              <select
                                value={this.state.selectedProcedureId}
                                id="procedureId"
                                onChange={(e) => this.onProcedureChange(e)}
                                placeholder="Select serviceline"
                                style={{
                                  display: "inline",
                                  height: "30px",
                                  borderRadius: "4px",
                                  backgroundColor: "#F9F9FB",
                                  width: "13vw",
                                }}
                              >
                                {this.state.treatmentGroupValue.map(
                                  (treatmentGroup) => (
                                    <option value={treatmentGroup.value}>
                                      {treatmentGroup.name}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                          </div>

                          <div className="row" style={{ marginTop: "1vw" }}>
                            <div className="col-sm-2">
                              <label
                                style={{ color: "black", fontSize: "15px" }}
                              >
                                Patient Contact Number
                              </label>
                            </div>
                            <div className="col-sm-1">:</div>
                            <div className="col-sm-2">
                              <input
                                type="text"
                                id="patientContactNumber"
                                name="patientContactNumber"
                                placeholder="Enter Patient Contact Number"
                                value={this.state.patientContactNumber}
                                onChange={this.handleChangeContactNumber}
                                style={{
                                  padding: "0.375rem 0.75rem",
                                  textAlign: "left",
                                  borderBottom: "1px solid #b2b2b2",
                                }}
                              />
                            </div>
                            <div className="col-sm-1"></div>
                            <div className="col-sm-2">
                              <label
                                style={{ color: "black", fontSize: "15px" }}
                              >
                                Treatment Date
                              </label>
                            </div>
                            <div className="col-sm-1">:</div>
                            <div className="col-sm-3">
                              <DatePicker
                                className="custom-datepicker"
                                style={{
                                  width: "10px",
                                  marginLeft: "70%",
                                  cursor: "pointer",
                                }}
                                autoOk={true}
                                id="treatmentDate"
                                selected={this.state.selectedTreatmentDate}
                                onChange={this.onTreatmentDateChange}
                                dateFormat="MM/dd/yyyy"
                              ></DatePicker>
                            </div>
                          </div>

                          <div className="row" style={{ marginTop: "1vw" }}>
                            <div className="col-sm-6"></div>
                            <div className="col-sm-2">
                              <label
                                style={{
                                  color: "black",
                                  fontSize: "15px",
                                  display:
                                    window.SCOPE_VALUE.CURRENT >
                                      window.SCOPE_VALUE.PHYSICIAN
                                      ? "inline"
                                      : "none",
                                }}
                              >
                                Provider
                              </label>
                            </div>
                            <div
                              className="col-sm-1"
                              style={{
                                display:
                                  window.SCOPE_VALUE.CURRENT >
                                    window.SCOPE_VALUE.PHYSICIAN
                                    ? "inline"
                                    : "none",
                              }}
                            >
                              :
                            </div>
                            <div className="col-sm-3">
                              <select
                                value={this.state.selectedPhysicianId}
                                id="physicianId"
                                onChange={(e) => this.onPhysicianChange(e)}
                                style={{
                                  display:
                                    window.SCOPE_VALUE.CURRENT >
                                      window.SCOPE_VALUE.PHYSICIAN
                                      ? "inline"
                                      : "none",
                                  height: "30px",
                                  borderRadius: "4px",
                                  backgroundColor: "#F9F9FB",
                                  width: "13vw",
                                }}
                              >
                                {this.state.providerGroupValue.map(
                                  (providerGroup) => (
                                    <option value={providerGroup.value}>
                                      {providerGroup.name}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                          </div>
                          <div className="row" style={{ marginTop: "1vw" }}>
                            <div className="col-sm-6"></div>
                            <div
                              className="col-sm-6"
                              style={{
                                display: this.state.showQrCodeButton
                                  ? "block"
                                  : "none",
                              }}
                            >
                              {/* <button
                                type="button"
                                className="btn action-button"
                                style={{
                                  marginTop: "6px",
                                }}
                                onClick={this.generateQRCode}
                              >
                                Generate QR Code
                              </button> */}
                              <button
                                type="button"
                                className="btn action-button"
                                style={{ marginTop: "6px" }}
                                onClick={this.resetFiltersAndData}
                              >
                                New Patient Enrollment
                              </button>
                              <div
                                className="modal"
                                style={{
                                  display: this.state.showQrCode
                                    ? "block"
                                    : "none",
                                }}
                              >
                                <div
                                  className="modal-dialog"
                                  id="center-aligned-account-modal"
                                  style={{ marginTop: "-13vh" }}
                                >
                                  <div
                                    className="modal-content"
                                    style={{
                                      height: "auto",
                                      marginTop: "10vw",
                                      width: "33vw",
                                      marginLeft: "19vw",
                                    }}
                                    Align="center"
                                  >
                                    <div className="modal-header noBorder">
                                      <button
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        id="close_id"
                                        onClick={this.closeQrCodePage}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                        >
                                          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                          <path d="M0 0h24v24H0z" fill="none" />
                                        </svg>
                                      </button>
                                    </div>
                                    <div className="modal-body">
                                      <h5 Align="center">On-boarding QR</h5>
                                      <form ref={(el) => (this.myFormRef = el)}>
                                        <a
                                          href={
                                            "https://www.myjeeva.net/?token=" +
                                            this.state.patientId
                                          }
                                          target="_blank"
                                        >
                                          <img
                                            id="qr_code"
                                            src={this.state.qrCode}
                                            style={{
                                              width: "21vw",
                                              marginLeft: "-1vw",
                                              height: "21vw",
                                            }}
                                          />
                                        </a>
                                      </form>
                                      <p>
                                        <b>Note: </b>Please open your My JEEVA
                                        app and scan the On-boarding QR
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default NewPatientAdmission;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/NewPatientAdmission.js